import React from 'react'
import { Form, Button, Row, Col } from 'react-bootstrap'
import {
  sanitizeAddressLine,
  sanitizeCity,
  sanitizeStateStrict,
  sanitizeCountry,
  formatPostalCode,
  normalizeCountryToISO,
} from '../utils/sanitize'

const AddressForm = ({ value, onChange, onSubmit, onCancel, submitLabel = 'Save' }) => {
  const v = value || { address1: '', address2: '', city: '', state: '', postalCode: '', country: '' }
  const set = (k, newVal) => onChange && onChange({ ...v, [k]: newVal })
  const onBlurState = (val) => {
    const iso = normalizeCountryToISO(v.country)
    set('state', sanitizeStateStrict(val, { country: iso, strict: iso === 'US' }))
  }
  return (
    <Form onSubmit={(e)=>{ e.preventDefault(); onSubmit && onSubmit() }}>
      <Row>
        <Col md={12}>
          <Form.Group controlId='addr1'>
            <Form.Label>Address 1</Form.Label>
            <Form.Control type='text' value={v.address1} maxLength={100} required onChange={(e)=>set('address1', e.target.value)} onBlur={(e)=>set('address1', sanitizeAddressLine(e.target.value))} />
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group controlId='addr2'>
            <Form.Label>Address 2</Form.Label>
            <Form.Control type='text' value={v.address2} maxLength={100} onChange={(e)=>set('address2', e.target.value)} onBlur={(e)=>set('address2', sanitizeAddressLine(e.target.value))} />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId='city'>
            <Form.Label>City</Form.Label>
            <Form.Control type='text' value={v.city} maxLength={64} required onChange={(e)=>set('city', e.target.value)} onBlur={(e)=>set('city', sanitizeCity(e.target.value))} />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId='state'>
            <Form.Label>State</Form.Label>
            <Form.Control type='text' value={v.state} maxLength={32} required onChange={(e)=>set('state', e.target.value)} onBlur={(e)=>onBlurState(e.target.value)} />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId='postal'>
            <Form.Label>Postal Code</Form.Label>
            <Form.Control type='text' value={v.postalCode} maxLength={10} required onChange={(e)=>set('postalCode', e.target.value)} onBlur={(e)=>set('postalCode', formatPostalCode(e.target.value, v.country))} />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group controlId='country'>
            <Form.Label>Country</Form.Label>
            <Form.Control type='text' value={v.country} maxLength={56} required onChange={(e)=>set('country', e.target.value)} onBlur={(e)=>set('country', sanitizeCountry(e.target.value))} />
          </Form.Group>
        </Col>
      </Row>
      <div className='d-flex gap-2 mt-3'>
        <Button type='submit' variant='primary'>{submitLabel}</Button>
        {onCancel && <Button variant='secondary' onClick={(e)=>{ e.preventDefault(); onCancel() }}>Cancel</Button>}
      </div>
    </Form>
  )
}

export default AddressForm
